import { TariffService } from './tariff';
import { TariffType } from '../../schema';

export async function findOneStandard (): Promise<TariffType> {
    return TariffService.findOneStandard();
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/tariff/tariff.find-one-standard.ts